import React, { useState } from "react";
import { Form, Button, message, Popconfirm } from "antd";
import { useParams } from "react-router-dom";
import FileUpload from "../../../Components/Uploader";
import { updateTop10ArticleImage } from "../action";

type Props = {
  fetchData: () => void;
};

const EditTop10ArticleImage = (props: Props) => {
  const { id } = useParams();
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [uploadedFile, setUploadedFile] = useState<{
    fileuploaded: boolean;
    name: string;
    folder: string;
  } | null>(null);

  const handleFileUploaded = (fileData: {
    fileuploaded: boolean;
    name: string;
    folder: string;
  }) => {
    setUploadedFile(fileData);
    message.success("File data saved to the form!");
  };

  const handleSubmit = () => {
    form
      .validateFields()
      .then(async (values) => {
        if (!uploadedFile) {
          message.error("Please upload an image before submitting.");
          return;
        }

        const formData = {
          ...values,
          image: uploadedFile,
        };

        const response = await updateTop10ArticleImage(
          id || "",
          formData.image.name
        );
        if (response) {
          message.success("Form submitted successfully!");
          props.fetchData();
        }
      })
      .catch((error) => {
        console.error("Validation failed:", error);
        message.error("Please correct the errors in the form.");
      });
  };

  return (
    <Form form={form} layout="vertical">
      <Form.Item label="Top 10 Article Image" required>
        <FileUpload onFileUploaded={handleFileUploaded} enableCrop />
      </Form.Item>

      <Form.Item>
        <Popconfirm
          title="Are you sure you want to modify image of this article?"
          onConfirm={handleSubmit}
          okText="Yes"
          cancelText="No"
        >
          <Button loading={isLoading} type="primary" className="w-full">
            {isLoading ? "Submiting..." : "Submit"}
          </Button>
        </Popconfirm>
      </Form.Item>
    </Form>
  );
};

export default EditTop10ArticleImage;
